import React, { useEffect } from 'react';
import { useAsync } from 'react-use';
import { useRouter } from 'next/router';
import { useAsyncFn } from '@zmedia/bm-soccer-ui/hooks';
import { ArrayUtils, ObjectUtils } from '@zmedia/bm-soccer-ui/utils';
import { PageService } from '@zmedia/bm-soccer-ui/service/PageService';
import { MatchService } from '@zmedia/bm-soccer-ui/service/MatchService';
import { TournamentRanking } from './ranking';
import { TournamentNews } from './news';
import { TournamentStatistic } from './statistic';
import { TournamentTeams } from './teams';
import { TournamentMatches } from './matches';
import { TournamentKnockout } from './knockout';
import { TournamentTransfer } from './transfer';
import { PageTournamentWrap } from '../components';
import { TournamentOverview } from './overview';
import { TAB_IDS } from '../../shared';
import { IContentItemClass } from '@zmedia/bm-soccer-ui/interface';

export function TournamentPageView({
    content,
    otherData = {},
    subSidebar = {},
    listProps,
}: {
    content: any;
    subSidebar: any;
    otherData: any;
    listProps: any;
}) {
    const router = useRouter();
    let data = content;
    const { id, seasonId } = router.query;

    if (ObjectUtils.isEmpty(data)) {
        const [state, callback] = useAsyncFn(PageService.getTournamentDetail);
        useEffect(() => {
            callback({ id, seasonId });
        }, [id, seasonId]);
        data = state.value?.data || {};
    }

    let items = otherData.items || [];

    if (ArrayUtils.isEmpty(items)) {
        const state = useAsync(
            () =>
                MatchService.getList({
                    listType: 'byTournament',
                    seasonId: data.seasonId,
                    listId: data.id,
                }),
            [data.seasonId, data.id]
        );

        const matches = state.value?.data || {};
        items = matches.items || [];
    }

    if (ObjectUtils.isEmpty(data)) {
        return null;
    }

    const renderTabs = () => {
        switch (data.activeTab) {
            case TAB_IDS.STANDING:
                return <TournamentRanking {...data} {...otherData} />;
            case TAB_IDS.NEWS:
                return (
                    <TournamentNews
                        {...data}
                        {...otherData}
                        listProps={Object.assign({}, listProps, {
                            ContentItemClass: {
                                CardClass: 'max-md:flex-row',
                                CardContentClass:
                                    'max-md:ml-[15px] md:mt-[7px]',
                                CardImageClass: 'md:w-full',
                            } as IContentItemClass,
                            ContentItemProps: {
                                showSapo: false,
                            },
                        })}
                    />
                );
            case TAB_IDS.STATISTIC:
                return <TournamentStatistic {...data} {...otherData} />;
            case TAB_IDS.TEAMS:
                return <TournamentTeams {...data} />;
            case TAB_IDS.MATCHES:
                return <TournamentMatches {...data} items={items} />;
            case TAB_IDS.KNOCKOUT:
                return <TournamentKnockout {...data} {...otherData} />;
            case TAB_IDS.TRANSFER:
                return <TournamentTransfer {...data} {...otherData} />;
            default:
                return (
                    <TournamentOverview
                        {...data}
                        {...otherData}
                        items={otherData?.matchesHot || items}
                        listProps={listProps}
                    />
                );
        }
    };

    return (
        <PageTournamentWrap {...data} {...subSidebar}>
            {renderTabs()}
        </PageTournamentWrap>
    );
}

export default TournamentPageView;
